module.exports = __webpack_public_path__ + "assets/img/success.ec8383ec.svg";